import { Component } from '@angular/core';

import { AuthorizationService } from '../../../shared/index';

@Component({
    selector: 'partsmanual-index',
    templateUrl: './partsmanual-index.html',
    standalone: false
})

export class PartsManualIndexComponent {
    constructor(
        private _authorizationService: AuthorizationService,
    ) {

    }
}
